import NavContent from "./Components/NavContent"
import Back from "./Components/Back"
export default function Container({items = []}) {
  return (
    <nav className="h-fit py-3 pr-5 flex items-center justify-between gap-3 border border-zi-blue-light rounded-2xl drop-shadow-md bg-zi-bg2-light dark:bg-zi-bg2-dark">
      <NavContent items={items}/>
      <Back/>
    </nav>
  )
}